import { Typography } from "@mui/material"

const TypoText = ({text}) => {

    return <Typography
      variant="body1"
      sx={{
        whiteSpace: 'normal',
        wordBreak: 'break-word',
        overflowWrap: 'break-word',
      }}
    >
      {text}
    </Typography>
}

export default TypoText